module.exports = __webpack_public_path__ + "img/1519586685.885729c9.jpg";